/**
 * @class Oskari.userinterface.request.ModalDialogRequest
 */
Oskari.clazz.define('Oskari.userinterface.request.ModalDialogRequest', function (title, message, buttons, onshow) {
  this._title = title || 'Untitled';
  this._message = message || 'Lorem ipsum';
  this._buttons = buttons || {};
  this._parent = parent || jQuery(Oskari.dom.getRootEl());
  this._onshow = onshow || null;
}, {
  __name: 'userinterface.ModalDialogRequest',
  getName: function getName() {
    return this.__name;
  },
  getTitle: function getTitle() {
    return this._title;
  },
  getMessage: function getMessage() {
    return this._message;
  },
  getButtons: function getButtons() {
    return this._buttons;
  },
  getGeom: function getGeom() {
    return this._geom;
  },
  getParent: function getParent() {
    return this._parent;
  },
  getOnShow: function getOnShow() {
    return this._onshow;
  }
}, {
  'protocol': ['Oskari.mapframework.request.Request']
});